"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagComponent = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const TagComponent = (props) => {
    const { name, type } = props;
    return react_1.default.createElement("span", { className: `tag-component small ${type}` }, name);
};
exports.TagComponent = TagComponent;
